<template>
  <div>
    <div class="content-header">
      <div class="left">资料库</div>
      <div class="right">
        <Button
          type="default"
          v-if="$CheckShow($route.name, 'EDIT')"
          style="margin-right: 10px"
          @click="
            () => {
              this.getCat();
              this.catModel.visible = true;
            }
          "
          >分类管理</Button
        >
        <Button
          icon="md-add"
          type="primary"
          v-if="$CheckShow($route.name, 'EDIT')"
          @click="uploadParams.visible = true"
          >新增</Button
        >
      </div>
      <div class="bottom"></div>
    </div>
    <div>
      <Table :columns="columns" :data="data">
        <template slot-scope="{ row }" slot="avatar">
          <div>
            <img
              :src="row.avatar"
              alt
              srcset
              v-if="row.avatar"
              style="height: 50px"
            />
            <span v-else>-</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="operation">
          <Dropdown
            trigger="click"
            @on-click="dropdownHandle(row.id, $event, index)"
          >
            <Icon type="ios-more" style="font-size: 25px; cursor: pointer" />
            <DropdownMenu slot="list">
              <DropdownItem style="font-size: 12px !important" name="rename"
                >重命名</DropdownItem
              >
              <DropdownItem style="font-size: 12px !important" name="sort"
                >排序</DropdownItem
              >
              <DropdownItem style="font-size: 12px !important" name="delete"
                >删除</DropdownItem
              >
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
      <div class="t-right t-top-10">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="page.total"
          show-elevator
          show-sizer
          show-total
        />
      </div>
    </div>
    <Modal v-model="uploadParams.visible" title="上传文件" width="600">
      <div>
        <Form ref="formInline" :label-width="100" inline>
          <FormItem prop="cat_id" label="选择分类:">
            <Select v-model="uploadParams.cat_id" style="width: 200px">
              <Option v-for="item in catData" :value="item.id" :key="item.id">{{
                item.name
              }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="sort" label="排序值:">
            <Input
              v-model="uploadParams.sort"
              type="number"
              placeholder="值越大排名越靠前"
              style="width: 200px"
            />
          </FormItem>
          <div style="padding-left: 30px">
            <div class="uploadBtnBox">
              <input
                type="file"
                accept="image/jpeg,image/jpg,image/png,video/mp4,.txt,.doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx"
                name=""
                ref="uploadBtn"
                id="uploadBtn"
                class="fileBtn"
                @change="uploadFile"
                style="display: none"
              />
              <Button
                icon="md-add"
                type="primary"
                size="small"
                class="btn"
                @click="clickUpload"
                >添加附件</Button
              >
            </div>
            <p style="font-size: 10px; color: #7b7b7b; margin-top: 10px">
              允许上传附件类型（pdf,doc,docx,xls,xlsx,txt,jpg,png,mp4,pptx），Mp4文件限20M/个，其它格式文件限10M/个，每个店铺文件总数限50个
            </p>
            <div class="fileListBox">
              <div
                v-for="(item, index) in uploadParams.list"
                :key="index"
                class="ivu-tag ivu-tag-size-default ivu-tag-default ivu-tag-closable ivu-tag-checked"
              >
                {{ item.file_name
                }}<i
                  class="ivu-icon ivu-icon-ios-close"
                  @click="cancelFile(index)"
                ></i>
              </div>
            </div>
          </div>

          <div style="height: 100px"></div>
        </Form>
      </div>
      <div slot="footer">
        <Button
          type="default"
          size="default"
          @click="uploadParams.visible = false"
          >取消</Button
        >
        <Button
          type="primary"
          size="default"
          :loading="uploadParams.loading"
          @click="saveFiles"
          >保存</Button
        >
      </div>
    </Modal>

    <Modal v-model="catModel.visible" title="分类管理" width="600" footer-hide>
      <Form ref="formInline" :label-width="100">
        <FormItem prop="name" label="分类名称:">
          <Input v-model="catModel.params.name" placeholder="请输入分类名称" />
        </FormItem>
        <FormItem prop="sort" label="分类排序:">
          <Input
            v-model="catModel.params.sort"
            type="number"
            placeholder="数值越大越靠前"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            size="default"
            :loading="catModel.loading"
            @click="saveCat"
            >保存</Button
          >
        </FormItem>
      </Form>
      <Table :columns="catModel.col" :data="catData" max-height="300"></Table>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { uploadOSS } from "@/libs/util";
export default {
  data() {
    return {
      columns: [
        {
          key: "file_name",
          title: "文件名称",
        },
        {
          key: "cat_name",
          title: "分类",
        },
        {
          key: "sizes",
          title: "大小",
          render(h, data) {
            return h(
              "span",
              {},
              data.row.sizes < 1024
                ? data.row.sizes + "KB"
                : (data.row.sizes / 1024).toFixed(2) + "MB"
            );
          },
        },
        {
          key: "sort",
          title: "排序",
        },
        {
          key: "create_time",
          title: "修改日期",
          render: (h, data) => {
            return h(
              "span",
              {},
              this.$moment(data.row.update_time || data.row.create_time)
            );
          },
        },
        {
          slot: "operation",
          title: "操作",
          width: 150,
        },
      ],
      data: [],
      page: {
        total: 0,
        l: 10,
        p: 0,
      },
      uploadParams: {
        visible: false,
        loading: false,
        cat_id: 0,
        sort: 0,
        list: [],
      },
      catData: [],
      catModel: {
        visible: false,
        loading: false,
        params: {
          id: 0,
          name: "",
          sort: 0,
        },
        col: [
          {
            key: "name",
            title: "分类名称",
          },
          {
            key: "sort",
            title: "分类排序",
          },
          {
            key: "action",
            title: "操作",
            render: (h, data) => {
              return [
                h(
                  "span",
                  {
                    class: "cat_btn",
                    props: { type: "text" },
                    style: { cursor: "pointer" },
                    on: {
                      click: () => {
                        this.catModel.params = data.row;
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "span",
                  {
                    class: "cat_btn",
                    props: { type: "text" },
                    style: { paddingLeft: "10px", cursor: "pointer" },
                    on: {
                      click: () => {
                        this.DeleteCat({ id: data.row.id }).then((res) => {
                          this.$Message[res.status ? "success" : "error"](
                            res.msg
                          );
                          if (res.status) {
                            this.getCat();
                            this.catModel.params = { id: 0, name: "", sort: 0 };
                          }
                        });
                      },
                    },
                  },
                  "删除"
                ),
              ];
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
    this.getCat();
  },
  methods: {
    ...mapActions([
      "GetFileList",
      "GetCat",
      "CreateFile",
      "SaveFile",
      "DeleteFile",
      "SaveCat",
      "DeleteCat",
    ]),
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    getData() {
      this.GetFileList(this.page).then((res) => {
        this.data = res.data;
        this.page.total = res.total;
      });
    },
    saveFiles() {
      this.$Spin.show();
      this.uploadParams.loading = true;
      this.uploadParams.list.map((item) => {
        item.sort = this.uploadParams.sort;
      });
      this.CreateFile({ data: this.uploadParams.list }).then((res) => {
        this.$Spin.hide();
        if (!res.status) {
          this.$Message.error(res.msg);
          this.uploadParams.loading = false;
          return false;
        }
        this.uploadParams = {
          visible: false,
          loading: false,
          cat_id: 0,
          list: [],
        };
        this.getData();
      });
    },
    getCat() {
      this.GetCat().then((res) => {
        this.catData = res.data;
      });
    },
    uploadFile(e) {
      console.log(e);

      let file = e.target.files[0];
      let arr = file.name.split(".");
      console.log("arr[arr.length - 1]", arr[arr.length - 1]);
      if (arr[arr.length - 1] === "mp4" && file.size / 1024 / 1024 > 20) {
        this.$Spin.hide();
        this.$Message.error("mp4文件不能大于20MB");
        return false;
      } else if (
        arr[arr.length - 1] !== "mp4" &&
        file.size / 1024 / 1024 > 10
      ) {
        this.$Spin.hide();

        this.$Message.error("文件不能大于10MB");
        return false;
      }
      uploadOSS(`shop/${this.current_user.shop_id}/archive/`, file).then(
        (oss) => {
          let data = {
            file_name: file.name,
            src: oss.url,
            cat_id: this.uploadParams.cat_id,
            sizes: (file.size / 1024).toFixed(2),
          };
          this.uploadParams.list.push(data);
          this.$Spin.hide();
        }
      );
    },
    clickUpload() {
      if (!this.uploadParams.cat_id) {
        this.$Message.warning("请先选择分类");
        return false;
      }
      if (this.uploadParams.list.length >= 1) {
        this.$Message.warning("单次最多上传1个文件");
        return false;
      }
      this.$refs.uploadBtn.click();
      this.$Spin.show();
    },
    cancelFile(index) {
      this.uploadParams.list.splice(index, 1);
    },
    dropdownHandle(id, name, index) {
      if (name === "rename") {
        this.handleRename(id, this.data[index].file_name);
      }
      if (name === "sort") {
        this.setSort(id, this.data[index].file_name);
      } else if (name === "delete") {
        this.deleteFile(id);
      }
    },
    handleRename(id, value) {
      this.$Modal.warning({
        title: "文件重命名",
        closable: true,
        render: (h) => {
          return h("Input", {
            props: {
              autofocus: true,
              placeholder: "请输入新的文件名称",
              value,
            },
            on: {
              input: (val) => {
                console.log("valval", val);
                if (!val) {
                  this.$Message.warning("文件名称为空，本次修改已取消");
                  return false;
                }
                this.SaveFile({ id, file_name: val }).then((res) => {
                  this.getData();
                });
              },
            },
          });
        },
      });
    },
    setSort(id, value) {
      this.$Modal.warning({
        title: "修改排序",
        closable: true,
        render: (h) => {
          return h("Input", {
            props: {
              autofocus: true,
              placeholder: "排序值越大越靠前",
              value,
              type: "number",
            },
            on: {
              input: (val) => {
                if (!val) {
                  this.$Message.warning("未填写排序值，本次修改已取消");
                  return false;
                }
                this.SaveFile({ id, sort: val }).then((res) => {
                  this.getData();
                });
              },
            },
          });
        },
      });
    },
    deleteFile(id) {
      this.$Modal.confirm({
        title: "确认框",
        content: "<p>是否确认删除当前文件？</p>",
        onOk: () => {
          this.DeleteFile({ id }).then((res) => {
            this.$Message[res.status ? "success" : "error"](res.msg);
            res.status && this.getData();
          });
        },
        onCancel: () => {},
      });
    },
    saveCat() {
      let data = JSON.parse(JSON.stringify(this.catModel.params));
      if (!data.name) {
        this.$Message.warning("请输入分类名称");
        return false;
      }
      if (!data.sort || data.sort < 0) data.sort = 0;
      this.catModel.loading = true;
      data.cat_id = this.uploadParams.cat_id || data.cat_id;
      this.SaveCat(data)
        .then((res) => {
          this.catModel.loading = false;
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (res.status) {
            this.getCat();
            this.catModel.params = { id: 0, name: "", sort: 0 };
          }
        })
        .catch((e) => {
          this.catModel.loading = false;
        });
    },
  },
  computed: {
    ...mapGetters(["current_user"]),
  },
  watch: {},
};
</script>
<style lang='less'>
@import "./index.less";
</style>
